/**
 * @file Renders a label next to the hot key that triggers it.
 */
import React from "react";
import { Typography } from "antd";

type Props = {
  hotKey: string;
  children: React.ReactNode;
}

/**
 * Renders the children next to the given hot key, as a keyboard-shortcut hint.
 */
const HotKey = ({
  hotKey,
  children,
}: Props) => {
  return (
    <div
      style={{
        gap: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {children}

      <Typography.Text
        type="secondary"
        style={{ fontSize: 12, marginRight: -8 }}
      >
        <kbd>{hotKey}</kbd>
      </Typography.Text>
    </div>
  );
};

export default HotKey;
